export type MarketingCardBackendType = {
  cta_title: string
  cta_link: string
  media: {
    type: 'video' | 'image'
    url: string
  }
  header_text: string
  sub_text: string
  is_dismissable: boolean
}

export type MarketingCardType = {
  ctaTitle: string
  ctaLink: string
  media: {
    type: 'video' | 'image'
    url: string
  }
  headerText: string
  subText: string
  isDismissable: boolean
}

export const parseMarketingCard = (data?: MarketingCardBackendType | null): MarketingCardType => {
  return {
    ctaTitle: data?.cta_title ?? '',
    ctaLink: data?.cta_link ?? '',
    media: {
      type: data?.media?.type ?? 'image',
      url: data?.media?.url ?? ''
    },
    headerText: data?.header_text ?? '',
    subText: data?.sub_text ?? '',
    isDismissable: data?.is_dismissable ?? false
  }
}
